import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const COMMENTS_ENDPOINT = `${BASE_URL}/comments`;
export async function getCommentsData() {
    try {
        const response = await axios.get(`${COMMENTS_ENDPOINT}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching comments data:', error);
    }
};

export async function patchCommentData(comment_id) {
    try {
        const response = await axios.patch(`${COMMENTS_ENDPOINT}/seen/${comment_id}`, null, {
            params: { seen_status: true }
          });
        return response.data;
    } catch (error) {
        console.error('Error updating comment data:', error);
    }
}

export async function deleteCommentData(comment_id) {
    try {
        const response = await axios.delete(`${COMMENTS_ENDPOINT}/${comment_id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting comment data:', error);
    }
}